import {
    createProperties,
    createRoot,
    type Field,
    Form,
    type FormState,
    type TypeToFields,
} from '@jmvdevelop/svelte-form';
import { z } from 'zod';
import { mergeObject } from '$lib/utils/mergeObject';

export const LoginFormData = z.object({
    email: z.string(),
    password: z.string(),
});

export type LoginFormData = z.infer<typeof LoginFormData>;
export type Fields<TFormValues> = TypeToFields<TFormValues, LoginFormData>;

export const empty: LoginFormData = {
    email: '',
    password: '',
};

export function createFields<TValues>(
    self: Field<TValues, LoginFormData>,
): Fields<TValues> {
    return {
        self: self,
        ...createProperties(self, ['email', 'password'] as const),
    };
}

export function validate<TValues>(
    _form: Form<TValues, string>,
    _fields: Fields<TValues>,
    state: FormState<TValues, string>,
) {
    return state;
}

export function createForm(
    id: string,
    initialValues: Partial<LoginFormData> = empty,
): [Form<LoginFormData, string>, Fields<LoginFormData>] {
    const fields = createFields<LoginFormData>(createRoot<LoginFormData>());
    const form = new Form<LoginFormData, string>(
        { initialValues: mergeObject(empty, initialValues) },
        id,
    );

    form.addValidator((state) => {
        return validate(form, fields, state);
    });

    return [form, fields];
}
